/**
 * The three shell snippets that go with a cleartext API token: the export line,
 * the MCP client command (`apps/mcp` reads `MOLT_API_URL` and `MOLT_API_TOKEN`,
 * `apps/mcp/src/config.ts`) and a `curl` call.
 *
 * The one builder: the member's reveal dialog
 * (`components/profile/ConnectedToolsSection.tsx`) and the superadmin's
 * hand-over (`components/admin/ApiTokensAdminSection.tsx`) both import it, so
 * UC-D9's "the MCP configuration snippet the member dialog already shows" holds
 * by construction. The member dialog builds it from this origin's `/api` (AT-14's
 * command, with that base in place of the production URL).
 *
 * The MCP command and the `curl` call name `$MOLT_API_TOKEN` rather than the
 * token, so the two commands most likely to be pasted into a ticket or a chat
 * carry no secret; the export line is the only snippet that holds it.
 */
export interface ApiTokenSnippets {
  readonly exportLine: string;
  readonly mcp: string;
  readonly curl: string;
}

export function apiTokenSnippets(apiBaseUrl: string, token: string): ApiTokenSnippets {
  return {
    exportLine: `export MOLT_API_TOKEN='${token}'`,
    mcp: [
      'claude mcp add molt -s user \\',
      `  -e MOLT_API_URL=${apiBaseUrl} -e MOLT_API_TOKEN="$MOLT_API_TOKEN" \\`,
      '  -- node /path/to/molt-v1/apps/mcp/dist/index.js',
    ].join('\n'),
    curl: `curl -H "Authorization: Bearer $MOLT_API_TOKEN" ${apiBaseUrl}/boards`,
  };
}
